import { t } from '../../i18n';
import { Skeleton } from '../feedback/Skeleton';

// Skeleton rows in a busy region that tells a screen reader Yükleniyor…, or label (B-ui §0.4); List and Timeline use
// them.
export function LoadingRows({ count, label }: { count: number; label?: string }) {
  return (
    <div aria-busy="true">
      <span className="sr-only">{label ?? t('components.Skeleton.loading')}</span>
      <ul aria-hidden>
        {Array.from({ length: count }, (_, index) => (
          <li key={index} className="flex items-center gap-3 p-4">
            <Skeleton className="size-10 shrink-0 rounded-full" />
            <div className="flex flex-1 flex-col gap-2">
              <Skeleton className="h-4 w-1/3" />
              <Skeleton className="h-4 w-2/3" />
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}
